"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFormState;
var _reactHookForm = require("react-hook-form");
function useFormState() {
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    _useFormContext$formS = _useFormContext.formState,
    touched = _useFormContext$formS.touched,
    isDirty = _useFormContext$formS.isDirty,
    dirtyFields = _useFormContext$formS.dirtyFields,
    isSubmitted = _useFormContext$formS.isSubmitted,
    isSubmitting = _useFormContext$formS.isSubmitting,
    isSubmitSuccessful = _useFormContext$formS.isSubmitSuccessful,
    submitCount = _useFormContext$formS.submitCount,
    isValid = _useFormContext$formS.isValid,
    isValidating = _useFormContext$formS.isValidating,
    errors = _useFormContext$formS.errors,
    getValues = _useFormContext.getValues,
    watch = _useFormContext.watch,
    reset = _useFormContext.reset,
    setValue = _useFormContext.setValue,
    trigger = _useFormContext.trigger;
  return {
    formState: {
      touched: touched,
      isDirty: isDirty,
      dirtyFields: dirtyFields,
      isSubmitted: isSubmitted,
      isSubmitting: isSubmitting,
      isSubmitSuccessful: isSubmitSuccessful,
      submitCount: submitCount,
      isValid: isValid,
      isValidating: isValidating,
      errors: errors
    },
    getValues: getValues,
    watch: watch,
    reset: reset,
    setValue: setValue,
    trigger: trigger
  };
}